import store from '../store'

// async function error(descritpion) {
//   await store.commit('notification/toast', {
//     type: 'error',
//     message: 'ผิดพลาด',
//     description: descritpion || 'กรอกข้อมูลให้ครบถ้วน'
//   })
//   await store.commit('notification/toastShow', {})
// }

// async function success(descritpion) {
//   await store.commit('notification/toast', {
//     type: 'success',
//     message: 'สำเร็จ',
//     description: descritpion || 'บันทึกข้อมูล'
//   })
//   await store.commit('notification/toastShow', {})
// }

async function error(descritpion) {
  await store.commit('notification/toastError', {
    message: 'ผิดพลาด',
    description: descritpion || 'กรอกข้อมูลให้ครบถ้วน'
  })
  await store.commit('notification/toastErrorShow', {})
}

async function success(descritpion) {
  await store.commit('notification/toastSuccess', {
    message: 'สำเร็จ',
    description: descritpion || 'บันทึกข้อมูล'
  })
  await store.commit('notification/toastSuccessShow', {})
}

function validatorShow(validators) {
  const msgErrors = []
  for (const i in validators) {
    msgErrors.push(validators[i][0])
  }
  error(msgErrors.join('<br>'))
}

function validatorShowData(res) {
  const msgErrors = []
  if (res.message && res.message !== '') {
    msgErrors.push(res.message)
  }
  if (res.data && res.data.length > 0) {
    for (const i in res.data) {
      msgErrors.push(`รายการที่ ${res.data[i].line_fail}. ${res.data[i].message}`)
    }
  }
  error(msgErrors.join('<br>'))
}
export default {
  error,
  success,
  validatorShow,
  validatorShowData
}
